/**
 * Format country + language codes as a compact badge for the feed selector.
 * Returns null when either input is missing — caller decides not to render.
 */
export function formatFeedBadge(
  country: string | null | undefined,
  language: string | null | undefined,
): string | null {
  if (!country || !language) return null;
  return `${country.toUpperCase()}/${language.toLowerCase()}`;
}

/**
 * Build a localized tooltip text like "German (Switzerland)" or "Deutsch (Schweiz)".
 * Uses Intl.DisplayNames; falls back gracefully if a code cannot be resolved.
 */
export function getFeedTooltip(
  country: string | null | undefined,
  language: string | null | undefined,
  uiLocale: string,
): string | null {
  if (!country || !language) return null;

  let countryLabel = country.toUpperCase();
  let languageLabel = language.toLowerCase();

  try {
    const region = new Intl.DisplayNames([uiLocale], { type: 'region' });
    const resolved = region.of(country.toUpperCase());
    if (resolved) countryLabel = resolved;
  } catch {
    // ignore — keep the raw code
  }

  try {
    const lang = new Intl.DisplayNames([uiLocale], { type: 'language' });
    const resolved = lang.of(language.toLowerCase());
    if (resolved) languageLabel = resolved;
  } catch {
    // ignore — keep the raw code
  }

  return `${languageLabel} (${countryLabel})`;
}
